module.exports = __webpack_public_path__ + "static/lendedu-logo@3x-acfb87afa5f8655d5d67e08e089fb51b.png";